module.exports = __webpack_public_path__ + "static/media/britishcouncilWhite@2x.2def3589.png";